<div class="card flex justify-center">
    <p-menu #menu [model]="items" [popup]="true" appendTo="body" />
    <!-- <p-button (click)="menu.toggle($event)" icon="pi pi-ellipsis-v"/> -->
    <p-button
        (click)="menu.toggle($event)"
        size="small"
        icon="pi pi-ellipsis-h"
        styleClass="aspect-square"
        severity="secondary" />
</div>
